import React from 'react';
import { useTranslation } from 'react-i18next';
import MessageModal from '@wix/da-ds/pkg/modals/dsPresets/MessageModal';
import { ConfirmButton } from '@wix/da-ds/pkg/modals/dsPresets/MessageModal/buttons';
import { Warning } from '@wix/da-ds/pkg/Icons/Confirmations/Warning';

interface Props {
  requestClose?: () => void;
}

const ScheduleLimitReachedErrorModal: React.FC<Props> = ({ requestClose }) => {
  const { t } = useTranslation();
  return (
    <MessageModal
      isOpen
      variant="horizontal"
      title={t('deviationSubmit.modals.scheduleLimitReached.title')}
      message={t('deviationSubmit.modals.scheduleLimitReached.message')}
      image={<Warning />}
      onRequestClose={requestClose}
      footerButtons={[
        <ConfirmButton key="confirm" onClick={requestClose}>
          {t('deviationSubmit.modals.scheduleLimitReached.confirmCta')}
        </ConfirmButton>,
      ]}
    />
  );
};
ScheduleLimitReachedErrorModal.displayName = 'ScheduleLimitReachedErrorModal';

export default ScheduleLimitReachedErrorModal;
